/**
 * @description Dydu API talk parameter
 */

export default Object.freeze({
  WEB: 'Web',
  VOCAL: 'Vocal',
  ANDROID: 'Android',
  IOS: 'iOS',
})
